import { render, staticRenderFns } from "./Reorder.vue?vue&type=template&id=3b19c411&scoped=true&"
import script from "./Reorder.vue?vue&type=script&lang=js&"
export * from "./Reorder.vue?vue&type=script&lang=js&"
import style0 from "./Reorder.vue?vue&type=style&index=0&id=3b19c411&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b19c411",
  null
  
)

export default component.exports